import { Box, Button, IconButton, Stack, Text } from "@chakra-ui/core";
import EditorContainer from "Components/Editor";
import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import NotChosen from "static/assets/SVGs/NotChosen";

const DeclineCard = () => {
  return (
    <Box p="5">
      <Text fontSize="lg" my="2" fontWeight="600">
        Decline Reason
      </Text>
      <EditorContainer />
      <Stack my="5" alignSelf="baseline">
        <Button variantColor="teal">Submit</Button>
      </Stack>
    </Box>
  );
};

function PreviewWindow({ chosenProfile }) {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  function changePage(offset) {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
  }
  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }
  return (
    <Box
      alignSelf="flex-start"
      mx="5"
      my="2"
      boxShadow="md"
      p="5"
      backgroundColor="white"
      borderRadius="0.5em"
    >
      <Text fontWeight="600">Preview Window</Text>
      {chosenProfile ? (
        <Box margin="0 auto">
          {chosenProfile.isDeclined ? (
            <DeclineCard />
          ) : (
            <>
              <Document
                file={chosenProfile.resume}
                onLoadSuccess={onDocumentLoadSuccess}
                className="pdf-viewer"
              >
                <Page pageNumber={pageNumber} />
              </Document>
              <Stack align="center">
                <Text>
                  Page {pageNumber || (numPages ? 1 : "--")} of{" "}
                  {numPages || "--"}
                </Text>
                <Stack isInline>
                  <IconButton
                    icon="chevron-left"
                    onClick={previousPage}
                    isDisabled={pageNumber <= 1}
                  />
                  <IconButton
                    icon="chevron-right"
                    onClick={nextPage}
                    isDisabled={pageNumber >= numPages}
                  />
                </Stack>
              </Stack>
            </>
          )}
        </Box>
      ) : (
        <Stack align="center">
          <NotChosen width="25vw" height="40vh" />
          <Text>Choose a Profile's resume to Preview</Text>
        </Stack>
      )}
    </Box>
  );
}

export default PreviewWindow;
